import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function RolePermissionMenu({ openItem = null, activeItem = null }) {
  return (
    <li
      className={`nav-item has-treeview 
                  ${sidebarHelper.checkOpenItem(openItem, "role-permission")} `}
    >
      <a
        href="# "
        className={`nav-link  
                  ${sidebarHelper.checkActiveItem(
                    openItem,
                    "role-permission"
                  )} `}
      >
        <i class="nav-icon far fa-hand-rock"></i>
        <p>
          نقش ها و دسترسی ها
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/roles/all"
            className={`nav-link  
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "role-all"
                      )} `}
          >
            <i className="fa fa-list nav-icon"></i>
            <p>همه نقش ها</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/permission/all"
            className={`nav-link  
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "permission-all"
                      )} `}
          >
            <i className="fa fa-list  nav-icon"></i>
            <p>همه دسترسی ها</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}

export default RolePermissionMenu;
